export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20dark%20background%20with%20soft%20red%20and%20amber%20gradient%20lighting%2C%20abstract%20geometric%20shapes%20with%20glowing%20edges%2C%20luxurious%20theater%20atmosphere%2C%20velvet%20texture%20feeling%2C%20deep%20shadows%20with%20warm%20highlights%2C%20elegant%20entertainment%20aesthetic%2C%20no%20people%2C%20artistic%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLElement).parentElement!.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 backdrop-blur-sm mb-6">
              <i className="ri-flashlight-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium tracking-wide">每日更新 · 海量资源 · 高清流畅</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-4">
              91麻豆免费视频网站
              <br className="hidden sm:block" />
              <span className="text-accent-400">海量免费高清视频在线观看</span>
            </h1>

            <p className="text-white/50 text-base md:text-lg font-heading mb-6 tracking-wide">
              随时随地，想看就看 — 你的专属免费视频平台
            </p>

            <div className="space-y-3 text-white/75 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                91麻豆免费视频网站是深受用户喜爱的<strong className="text-white/90">免费视频在线观看</strong>平台，
                汇集海量<strong className="text-white/90">91免费在线视频</strong>资源，
                涵盖热门频道与<strong className="text-white/90">91免费视频网站</strong>精选内容。
              </p>
              <p>
                平台每日持续更新优质资源，<strong className="text-white/90">在线免费视频网站</strong>一站式服务，
                <strong className="text-white/90">免费高清视频在线</strong>流畅播放不缓冲，
                无论是<strong className="text-white/90">91福利在线视频</strong>还是热门推荐，
                都能在这里轻松找到。
              </p>
              <p>
                当前热门专题涵盖多元题材，<strong className="text-white/90">91在线观看视频网站</strong>拥有丰富的分类体系，
                <strong className="text-white/90">91福利视频在线</strong>每日上新，让每一次访问都有新发现。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10,000+</div>
                <div className="text-xs text-white/50 mt-1">视频资源</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-white/50 mt-1">365天不间断</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">高清流畅</div>
                <div className="text-xs text-white/50 mt-1">即点即播</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20warm%20red%20and%20gold%20lighting%2C%20elegant%20velvet%20curtain%20texture%2C%20soft%20glowing%20neon%20accents%2C%20luxurious%20theater%20interior%20abstract%2C%20film%20projector%20light%20beam%20effect%2C%20artistic%20composition%20with%20dramatic%20shadows%2C%20sophisticated%20entertainment%20aesthetic%2C%20no%20explicit%20content%2C%20stylized%20moody%20visual&width=1040&height=1300&seq=hero-visual-main&orientation=portrait"
                alt="91麻豆免费视频网站 - 海量高清视频在线观看"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="text-white text-sm font-semibold">高清视频在线</div>
                    <div className="text-white/60 text-xs">即点即播 · 无需下载</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}